import * as z from 'zod';

import { brandQueryLinkerSchema } from '@/_pages/settings/brands/shared';
import { inventoryBinLocationQuerySchema } from '@/_pages/settings/inventory-bin-locations/shared/schemas';
import { inventoryCategoryQueryLinkerSchema } from '@/_pages/settings/inventory-categories/shared/schemas';
import { inventoryVendorQuerySchema } from '@/_pages/settings/inventory-vendors/shared/schemas';
import { inventoryVolumeQueryLinkerSchema } from '@/_pages/settings/inventory-volumes/shared/schemas';
import { fileQuerySchema } from '@/_schemas/file';
import {
  currencyInput,
  nullableBooleanQuerySchema,
  nullableNumericQuerySchema,
  paginatedResponseSchema,
} from '@/_schemas/generic';
import { statusQuerySchema } from '@/_schemas/status-input';

import { inventoryQueryLinkerSchema } from './inventory-query-linker-schema';

import { skusQuerySchema } from '../skus';
import { vendorDetailsQuerySchema } from '../vendor-details';

const inventoryQuerySchemaBase = z.object({
  ...inventoryQueryLinkerSchema.shape,
  status: statusQuerySchema,
  manufacturer: z.string().nullable(),
  manufacturer_id: z.string().nullable(),

  description: z.string().nullable(),
  secondary_skus: skusQuerySchema.nullish(),
  committed: nullableNumericQuerySchema(),

  images: z.array(fileQuerySchema).nullish(),

  category_id: z.number(),
  inventory_category: inventoryCategoryQueryLinkerSchema,
  inventory_volume_id: z.number().nullish(),
  inventory_volume: inventoryVolumeQueryLinkerSchema.nullish(),

  weight: nullableNumericQuerySchema(),
  last_order_cost: currencyInput.querySchema(),

  minimum_stock: nullableNumericQuerySchema(),
  maximum_stock: nullableNumericQuerySchema(),

  units_per_order: nullableNumericQuerySchema(),
  minimum_order: nullableNumericQuerySchema(),

  track_stock_quantities: nullableBooleanQuerySchema(),
  track_serial_numbers: nullableBooleanQuerySchema(),
  discontinued: nullableBooleanQuerySchema(),

  bin_locations: z.array(inventoryBinLocationQuerySchema).nullish(),

  brand: brandQueryLinkerSchema.nullish(),
  brand_id: z.number().nullish(),

  parent: inventoryQueryLinkerSchema.nullish(),
  parent_id: z.number().nullish(),

  logo: z.array(fileQuerySchema).nullish(),

  vendors: z.array(inventoryVendorQuerySchema).nullish(),
  vendor_details: z.array(vendorDetailsQuerySchema).nullish(),
});

export const inventoryQuerySchema = inventoryQuerySchemaBase.extend({
  children: z.array(inventoryQuerySchemaBase).nullish(),
});

export type InventoryQuerySchema = z.infer<typeof inventoryQuerySchema>;

export const inventoryQueryAllSchema = paginatedResponseSchema(inventoryQuerySchema);

export type InventoryQueryAllSchema = z.infer<typeof inventoryQueryAllSchema>;
